module.exports = __webpack_public_path__ + "public/files/img/7.36f1e648.png";